import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from 'primeng/api';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-dashboard-custom-filter',
  templateUrl: './dashboard-custom-filter.component.html',
  styleUrl: './dashboard-custom-filter.component.scss',
  imports: [SharedModule, MatCheckboxModule, MatTooltipModule]
})
export class DashboardCustomFilterComponent {
  @Input() filterName: string;
  @Input() NoOfRecords: string;
  @Input() filterId: any;
  @Input() checked: boolean;
  @Output() valueEmitted = new EventEmitter<string>();

  constructor() { }

  emitCustomValue() {
    this.valueEmitted.emit(this.filterId);
  }
}
